// The bare ticker context, so leaf hooks (useUnifiedBetCard) can read fixtures
// without importing TickerContext.jsx and its network/auth dependencies.
import { createContext } from 'react';

const TickerContext = createContext();
export default TickerContext;
